import React,{ Component } from 'react';
import PropTypes from 'prop-types';

import {
  Row,
  Col,
  Input,
  FormGroup,
  Label
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import TextInput from '../../../shared/components/TextInput';
import MoneyInput from '../../../shared/components/MoneyInput';
import Button from '../../../shared/components/Button';

import find from 'lodash/find';

import { 
  formatPaymentMethod
} from '../../../shared/utils';

class AccountNewIO extends Component {
  constructor(){
    super();

    this.state = {
      isLoaded:false,
      error:null,
      validationMessages:{}
    };
  }

  componentDidMount(){
    const {
      loadPaymentMethodsForAgency,
      accountId
    } = this.props;

    Promise
      .all([ loadPaymentMethodsForAgency(accountId) ])
      .then(() => this.setState({isLoaded:true}))
      .catch((err) => this.setState({error:err}));
  }

  handleSubmit(data){
    const {
      accountId,
      paymentMethods,
      createIO
    } = this.props;

    const selectedPaymentMethod = find(paymentMethods, (p) => p.id === data.paymentMethodId);

    const validationMessages = {};

    if(!data.amount || parseFloat(data.amount) === 0){
      validationMessages['amount'] = 'Amount is required';
    }

    if(!data.io || data.io.length === 0){
      validationMessages['io'] = 'Notes is required';
    }

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      return;
    } else {
      this.setState({validationMessages:{}});

      createIO(accountId,data.paymentMethodId,parseFloat(data.amount),data.io)
        .then(() => this.handleSuccess())
        .catch((err) => this.handleError(err))
    }
  }

  handleSuccess(){
    const { history, accountId, redirectURL  } = this.props;
    
    if(redirectURL){
      history.push(redirectURL);
    } else {
      history.push(`/superadmin/accounts/${accountId}/billing`);
    }
  }

  handleError(err){}

  render(){
    const {redirectURL,accountId,paymentMethods} = this.props;

    const {validationMessages} = this.state;

    return (
      <div className='AccountNewIO'>
        <Row>
          <Col xs='12' md='6'>
            <br />
            <h3>New IO</h3>
            <br />
            <Form onSubmit={(data) => this.handleSubmit(data)}>
              <MoneyInput label='Amount' name='amount' warning={validationMessages['amount']} />
              <FormGroup>
                <Label>Payment Method</Label>
                <Input type='select' name='paymentMethodId'>
                  {paymentMethods.filter((p) => p.kind !== 'card').map((p) => (
                    <option key={p.id} value={p.id}>
                      {formatPaymentMethod(p)}
                    </option>
                  ))}
                </Input>
              </FormGroup>
              <TextInput label='Notes' name='io' warning={validationMessages['io']}/>
              <Button isSubmit>Create IO</Button>
              <Button
                linkHref={redirectURL ? redirectURL : `/superadmin/accounts/${accountId}/billing`}
                className='float-right'
                textColor='#666666'
                borderColor='#cccccc'
                backgroundColor='#ededed'
              >
                Cancel
              </Button>
            </Form>
          </Col>
        </Row>
      </div>
    );
  }
}

AccountNewIO.propTypes = {
  //TODO: Fill in prop types for AccountNewIO
};

AccountNewIO.defaultProps = {
  //TODO: Fill in defaultProps for AccountNewIO
};

export default AccountNewIO;



// WEBPACK FOOTER //
// ./src/routes/AccountNewIO/components/AccountNewIO.js